import { MailPrefill } from '@agent-ds/shared/interfaces';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {  MailPopupType, MailSendConfig } from '../mail-send/config';
import { MailSendComponent } from '../mail-send/mail-send.component';
import { PopupControlComponent } from '../popup-control/popup-control.component';

@Component({
  selector: 'ag-mail-send-flow-dialog',
  templateUrl: './mail-send-flow-dialog.component.html',
})
export class MailSendFlowDialogComponent implements OnInit, OnDestroy {
  private static INSTANCE: MailSendFlowDialogComponent | null = null;
  public static get instance(): MailSendFlowDialogComponent | null {
    return MailSendFlowDialogComponent.INSTANCE;
  }

  @ViewChild(MailSendComponent, { static: true }) mailSend: MailSendComponent;
  @Output() sent = new EventEmitter<any>();
  @Output() closed = new EventEmitter<any>();

  private currentFlowIndex = null;

  constructor() {
    if (MailSendFlowDialogComponent.INSTANCE == null) {
      MailSendFlowDialogComponent.INSTANCE = this;
    }
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    if (MailSendFlowDialogComponent.INSTANCE === this) {
      MailSendFlowDialogComponent.INSTANCE = null;
    }
  }

  public set config(sendConfig: MailSendConfig) {
    this.mailSend.config = sendConfig;
  }

  public start(prefill?: MailPrefill): void {
    this.closeFlow();
    this.mailSend.reset(prefill);
    this.mailSend.update();
    this.currentFlowIndex = -1;
    this.next();
  }

  public close(closeSender = false): void {
    if (closeSender) {
      this.mailSend.close();
      return;
    }
    this.closeFlow();
    this.closed.emit();
  }

  public closeFlow(): void {
    this.currentFlowIndex = null;
    PopupControlComponent.closeAll();
  }

  private next(): void {
    if (this.currentFlowIndex != null) {
      const config = this.mailSend.config.getPopupConfig()[++this.currentFlowIndex];
      if (config) {
        setTimeout(() => this.openPopup(config.type));
      } else if (!this.mailSend.config.sendAfterFlow()) {
        this.closeFlow();
        this.mailSend.config.initForm();
      } else {
        this.mailSend.confirm(true);
      }
    } else {
      PopupControlComponent.closeAll();
    }
  }

  public openPopup(type: MailPopupType): void {
    const popupConfig = this.mailSend.config.getPopupConfig().find((c) => c.type === type);
    if (!popupConfig) {
      return;
    }
  }
}
